import React, { Component } from 'react';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import { map} from 'lodash';
import {imageBasePath} from "../../constants/staticData";

export default class ChangeTax extends Component {
    constructor(props) {
        super(props);
this.initialFormData = {
      'vat': "",
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      'vat': false,
      // 'terms': false
    };
      this.state = {
        vat: "",
        propsAvoid: false,
        buttonLoading: false
      };
    this.onSubmit=this.onSubmit.bind(this);
    this.onFieldChange=this.onFieldChange.bind(this);
    }

    componentWillUnmount() {
     this.props.actions.hideErrorMessage();

    }


  componentWillMount() {
    this.props.actions.getBusinessTax();
  }



  componentWillReceiveProps(nextprops) {


      if(! this.state.buttonLoading){
        this.setState({
          vat:  nextprops.commonReducer && nextprops.commonReducer.hasOwnProperty('taxInfo') && nextprops.commonReducer.taxInfo.length && nextprops.commonReducer.taxInfo ?  nextprops.commonReducer.taxInfo[0].value: "",
        })
      }




  }
  onFieldChange(value, name, key) {
      this.setState({formError :false});
      this.formData[name] = value;
      this.errors[name] = value ? false : true;
    this.setState({
      vat:value
    });
    }
 onSubmit() {
   let data = null;
   let a = document.getElementsByClassName('form-group');
   map(a, function (value, key) {
     data += value.className;
   });
   let checkError = data.indexOf('error') !== -1 ? true : false;

   if (! checkError) {
     let garage_id = JSON.parse(localStorage.getItem('garage_id'));

     let taxData = {
       "garage_id": garage_id,
       "taxes": [{
           "name": "VAT",
           "value": this.state.vat,
           "type": "PERCENTAGE" ,
           "description": ""
         }]
       };
     this.props.actions.updateBusinessTax(taxData);
     this.state.propsAvoid = false;
     this.setState({
       buttonLoading: true
     })
   }
 }


    render() {

      const {authReducer, useraccountReducer} = this.props;

      return (
            <div>
                <div className="password-form-info password-form-info-mob">
                <TextInput
                        type="text"
                        label="VAT"
                        name="vat"
                        value={this.state.vat}
                        showValidationError={this.errors['vat']}
                        validationError="Enter VAT "
                        onBlur={this.onFieldChange.bind(this)} />
                  <div className="form-group bottom-controls visible-xs">
                    <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">

                      <div className="row visible-xs">
                        <div className="col-xs-6 add-veh-mob">
                          <Button
                            btnType="label"
                            btnSize="sm"
                            fontSize={16}
                            label="Save"
                            btnCallBack={() => this.onSubmit(this)}
                            customClass="btn-theme-save add-vehcile-save-btn"
                          />
                        </div>
                        <div className="col-xs-6 add-veh-mob hidden-xs">
                          <Button
                            btnType="label"
                            btnSize="sm"
                            fontSize={16}
                            label="Cancel"
                            btnCallBack={() => window.history.back()}
                            customClass="btn-theme add-vehcile-cancel-btn"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
                <Button btnType="label" btnSize="sm" fontSize={16} label="Save" btnCallBack={()=>this.onSubmit(this)}  customClass="btn-theme-save hidden-xs"/>

              </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UserAccounts/ChangeTax.jsx